import { useState } from "react";
import { Navigate } from "react-router-dom";
import {
  isAuthenticated,
  isAdmin,
  isUser,
  logout,
} from "../../services/UserService";
import { jwtDecode } from "jwt-decode";
import { Box } from "@mui/material";
import Sidebar from "../../pages/global/Sidebar";
import Topbar from "../../pages/global/Topbar";

const PrivateRoute = ({ children, requiredRole }) => {
  const authenticated = isAuthenticated();

  // Token expiration check
  const token = localStorage.getItem("token");
  if (token) {
    const { exp } = jwtDecode(token);
    const isExpired = Date.now() >= exp * 1000;
    if (isExpired) {
      logout(); // Log out if token is expired
      return <Navigate to="/login" replace />;
    }
  }

  // Redirect to login if not authenticated
  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to dashboard if role is not sufficient
  if (
    (requiredRole && requiredRole === "ADMIN" && !isAdmin()) ||
    (requiredRole === "USER" && !isUser())
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  // If authenticated and authorized, render the layout with sidebar and topbar
  return (
    <Box display="flex" className="app">
      <Sidebar />

      <Box
        flexGrow={1}
        overflow="auto"
        sx={{
          transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <Topbar />
        {children}
      </Box>
    </Box>
  );
};

export default PrivateRoute;
